import { Box, Button, Divider, Input, Sheet, Typography } from "@mui/joy";
import { useProjectIDs } from "../../routes/project";
import { useProject } from "../../redux/project/projectHooks";
import { useDispatch } from "react-redux";
import { setFormOpen, setSelectedProjectIDs } from "../../reducers/rhapsody";
import { useSeasons } from "../../redux/season/seasonHooks";

/**
 *
 * @returns {ReactElement} ProjectGeneral page
 */
export function ProjectGeneral() {
  const projectIDs = useProjectIDs();
  const { project, isLoading } = useProject(projectIDs);
  const { seasons } = useSeasons();
  const dispatch = useDispatch();

  const season = seasons.find((s) => s.id === project.seasonID);

  return (
    <Box
      sx={{
        maxWidth: 600,
        width: "100%",
        flexDirection: "column",
        gap: 1,
        display: "flex",
        alignItems: "stretch",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      {project.sourceID === 420 ? (
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Button
            onClick={() => {
              dispatch(setSelectedProjectIDs(projectIDs));
              dispatch(setFormOpen({ isOpen: true, formID: "project" }));
            }}
            variant="soft"
            color="neutral"
            startDecorator={<i className="fa-solid fa-pen"></i>}
          >
            Edit
          </Button>
        </Box>
      ) : (
        <></>
      )}
      <Box>
        <Typography level="body3">ABOUT THE PROJECT</Typography>
        <Sheet variant="soft" sx={{ borderRadius: 8 }}>
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"ID:"}
            value={project?.id}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Name:"}
            value={project?.name}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Description:"}
            value={project?.description}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Season:"}
            value={season?.name ?? ""}
          />
        </Sheet>
      </Box>
    </Box>
  );
}
